<template lang="pug">
    v-content
        v-toolbar(flat="" color="white")
            v-toolbar-title סנדי - הגדרות עיצוב
            v-divider.mx-2(inset="" vertical="")
            v-spacer
            v-dialog(v-model="dialog" max-width="800px").rtl
                v-btn.mb-2(slot="activator" color="primary" dark="") שורת עיצוב חדשה
                v-card
                    v-card-title
                        span.headline {{ formTitle }}
                    v-card-text
                        v-container(grid-list-md="").rtl
                            v-layout(wrap="")
                                v-flex(xs12)
                                    v-text-field(reverse right v-model="editedItem.screen_id" label="מזהה מסך")
                                v-flex(xs12)
                                    v-text-field(reverse right v-model="editedItem.column_name" label="שם העמודה המתעצבת")
                                v-flex(xs12).ltr
                                  v-switch(v-model="editedItem.apply_to_title" label="להחיל גם על הכותרת?")
                                v-flex(xs12)
                                    v-text-field(reverse right v-model="editedItem.column_for_comparison" label="איזו עמודה להשוות")
                                v-flex(xs12)
                                    v-select(v-model="editedItem.type_of_condition" :items="['includes','<', '>', '=', 'שעות מעכשיו', 'תמיד', '!=', 'not includes']", item-text="he_value" item-value="value" label='סוג התנאי')
                                v-flex(xs12)
                                    v-text-field(reverse right v-model="editedItem.condition_value" label="ערך להשוואת התנאי")
                                v-flex(xs12).ltr
                                  input(type="color" v-model="color55644")
                                  span {{ color55644 }}
                                v-flex(xs12).ltr
                                    v-textarea(solo v-model="editedItem.css" label="CSS")

                    v-card-actions
                        v-spacer
                        v-btn(color="blue darken-1" flat="" @click="close") Cancel
                        v-btn(color="blue darken-1" flat="" @click="save(editedItem)") Save
        v-data-table#setting-table.elevation-1(
                :headers="headers"
                :items="desserts"
                :loading='loading'
                :rows-per-page-items="rowsPerPageItems"
                :pagination.sync="pagination"
            )
            template(slot="items" slot-scope="props")
                td.text-xs-right {{ props.item.id                                   }}
                td.text-xs-right {{ props.item.screen_id                           }}
                td.text-xs-right {{ props.item.column_name                           }}
                td.text-xs-right {{ props.item.column_for_comparison                           }}
                td.text-xs-right {{ props.item.type_of_condition                           }}
                td.text-xs-right {{ props.item.condition_value                           }}
                td.text-xs-right {{ props.item.css                           }}

                td.justify-center.layout.px-0
                    v-icon.ml-4(small="" @click="deleteItem(props.item)") delete
                    v-icon.ml-4(small="" @click="editItem(props.item)") edit
                    v-tooltip.v-icon.ml-4(top)
                        v-icon(slot='activator' small @click="save(props.item, true)") repeat_one
                        span שכפל
                    router-link(tag="a" :to="'/screen/'+props.item.screen_id" target='_blank' style="display: inline-flex; color: transparent;")
                        v-icon.ml-4(small) send
</template>

<script>
    export default {
        data: () => ({
          color55644: '',
            sort_options_system: {ASC : 'ישר', DESC : 'הפוך'},
            sort_options: [{value : 'ASC', he_value : 'ישר'}, {value : 'DESC', he_value : 'הפוך'}],
            loading: true,
            dialog: false,
            rowsPerPageItems: [10, 20, 50, 100, 1000],
            pagination: {
                rowsPerPage: 1000
            },
            headers: [
              { text: 'id'                    , value: 'id'                        , sortable: false, align : 'right' },
              { text: 'מזהה מסך'              , value: 'screen_id'                 , sortable: false, align : 'right' },
              { text: 'שם העמודה המתעצבת'     , value: 'column_name'               , sortable: false, align : 'right' },
              { text: 'איזו עמודה להשוות'     , value: 'column_for_comparison'     , sortable: false, align : 'right' },
              { text: 'סוג התנאי'             , value: 'type_of_condition'         , sortable: false, align : 'right' },
              { text: 'ערך להשוואת התנאי'     , value: 'condition_value'           , sortable: false, align : 'right' },
              { text: 'css'                   , value: 'css'                       , sortable: false, align : 'right' },
              { text: 'פעולות'                                                     , sortable: false, align : 'right' },
            ],
            columns_style: [],
            desserts: [],
            editedItem: {},
        }),

        computed: {
            formTitle () {
                return this.editedIndex === -1 ? 'שורת עיצוב חדשה' : 'ערוך שורת עיצוב'
            }
        },

        watch: {
            dialog (val) {
                val || this.close()
            }
        },

        created () {
          document.title = 'הגדרות עיצוב';

          this.$socket.on('*', (packet) => {
                let channel = packet.data[0];
                let data = packet.data[1];
                let $uniqid = data.$uniqid;
                if($uniqid) {
                    return this.$socket.res(data);
                }
                this.sockets(channel, data);
            });

            this.initialize();
            this.$emit('update:loading', false);
        },
        beforeRouteLeave(to, from, next) {
            this.$socket.off('*');
            this.$emit('update:loading', true);
            next();
        },

        methods: {
            range(first, last) {
                let a = first.charCodeAt(0)
                let b = last.charCodeAt(0) + 1
                return Array.apply(null, {length: Math.abs(b - a)})
                    .map(function (x,i) { return String.fromCharCode(Math.min(a, b) + i) });
            },


            initialize () {
                this.$socket.req('sendi.screen.style.all').then(data => {
                    this.desserts = data.entities;
                        setTimeout(()=> {
                            document.getElementsByClassName('v-table__overflow')[0].scrollLeft = 20000;
                            this.loading = false;
                        });
                });
            },

            sockets : function (channel, data) {
                let channels = {
                    'sum.channel' : (/*data*/) => {
                        //console.log('sum.channel', data)
                    }
                };
                if(!channels[channel]) {
                    return console.log('Socket channel not found:', channel);
                }

                return channels[channel](data);
            },


            editItem (item) {
                this.editedIndex = this.desserts.indexOf(item) || {};
                this.editedItem = {...item};
                this.dialog = true
            },

            deleteItem (item) {
                confirm(`בטוח? למחוק את
                    ${item.name}
                `) && this.$socket.req('sendi.screen.style.delete', {
                    id    : item.id
                }).then(() => {
                    this.initialize();
                });
            },


            close () {
                this.dialog = false
            },

            save (item, duplicate = false) {
                this.loading = true;

                if (duplicate) {
                    item = { ...item };
                    delete item['id'];
                }

                this.$socket.req('sendi.screen.style.editOrAdd', item).then(data => {
                    let itemIdx = this.desserts.findIndex(v => v.id == data.item.id);

                    if(itemIdx > -1) {
                        // this.desserts[itemIdx] = data.item;
                        this.initialize();
                    }
                    else {
                        this.desserts.push(data.item);
                    }


                    this.loading = false;
                    this.editedItem = {};
                });
                this.close()
            }
        }
    }
</script>

<style lang="sass">

    #setting-table .v-table__overflow
        /*height: 300px;*/
        overflow-y: auto
        /*direction: rtl;*/


    #setting-table .v-datatable.v-table
        direction: rtl

    #setting-table .v-datatable__actions
        direction: ltr


    .v-content__wrap
        background: #fff
    #setting-table
        table.v-table tbody td:first-child, table.v-table tbody td:not(:first-child), table.v-table tbody th:first-child, table.v-table tbody th:not(:first-child), table.v-table thead td:first-child, table.v-table thead td:not(:first-child), table.v-table thead th:first-child, table.v-table thead th:not(:first-child)
            padding: 0 5px

    .v-tooltip.v-icon span
        display: inline-flex


</style>